__turbopack_context__.v({
  "className": "comfortaa_262ff5af-module__jhP9oq__className",
});
